import { apiClient } from '@/shared/lib/apiClient';

export type CustomerMessageStatus = 'open' | 'in_progress' | 'resolved';

export type CustomerMessageItem = {
  id: string;
  product_slug: string;
  product_name: string;
  tenant_name: string;
  subject: string;
  body: string;
  status: string;
  created_by_email: string;
  created_by_name: string | null;
  attachments: Array<{ fileName: string; url: string; mimeType?: string }>;
  created_at: string;
  resolved_at: string | null;
};

type ApiSuccessResponse<T> = { success: true; data: T };

export async function fetchCustomerMessages(status?: string): Promise<{
  items: CustomerMessageItem[];
  total: number;
}> {
  const res = await apiClient.get<ApiSuccessResponse<{ items: CustomerMessageItem[]; total: number }>>(
    '/api/v1/admin/customer-messages',
    { params: status ? { status } : {} },
  );
  return res.data;
}

export async function updateCustomerMessageStatus(
  id: string,
  status: CustomerMessageStatus,
  adminNotes?: string,
): Promise<{ id: string; status: string }> {
  const res = await apiClient.patch<ApiSuccessResponse<{ id: string; status: string }>>(
    `/api/v1/admin/customer-messages/${id}`,
    { status, adminNotes },
  );
  return res.data;
}

export type CustomerMessageReplyItem = {
  id: string;
  author_type: 'admin' | 'customer';
  author_name: string | null;
  body: string;
  created_at: string;
};

export type CustomerMessageThread = {
  id: string;
  subject: string;
  body: string;
  status: string;
  replies: CustomerMessageReplyItem[];
};

export async function getCustomerMessageThread(id: string): Promise<CustomerMessageThread> {
  const res = await apiClient.get<ApiSuccessResponse<CustomerMessageThread>>(
    `/api/v1/admin/customer-messages/${id}`,
  );
  return res.data;
}

export async function addAdminReply(
  id: string,
  body: string,
  adminUserName?: string,
): Promise<{ id: string; created_at: string }> {
  const res = await apiClient.post<ApiSuccessResponse<{ id: string; created_at: string }>>(
    `/api/v1/admin/customer-messages/${id}/replies`,
    { body, adminUserName },
  );
  return res.data;
}
